import Vue from "vue";
import Router from "vue-router";
import router from "@/router";
import { getToken } from "../utils/auth.js";
import productList from "@/view/productList";
import productCardListPage from "@/view/productList/module/ProductCardListPage";
import login from "@/view/login";
import sign from "@/view/sign";
import productDetail from "@/view/productDetail";
import productPoster from "@/view/productPoster";
import searchProduct from "@/view/searchProduct";
import productInformation from "@/view/productInformation";
import supplementInfo from "@/view/supplementInfo";
import accountCenter from "@/view/accountCenter";
import authentication from "@/view/accountCenter/module/authentication";
import myCustomer from "@/view/myCustomer";
import productCollection from "@/view/productCollection";
// 退役军人服务平台 xrr
import productCollectionForXrr from "@/view/productCollectionForXrr";
import companyRep from "@/view/companyRep";
import companyRepCode from "@/view/companyRepCode";
import companyRepCodeInfo from "@/view/companyRepCodeInfo";
import reservation from "@/view/reservation";
import posterPage from "@/view/operatingManual/module/posterPage";
import reservationRecord from "@/view/reservationRecord";
import operatingManual from "@/view/operatingManual";
import newsList from "@/view/newsList";
import productSummary from "@/view/productSummary";
import imgPage from "@/view/imgPage";
import carLoanCustomers from "@/view/carLoanCustomers";
import lowerLevelChannels from "@/view/lowerLevelChannels";
import applyRecord from "@/view/myCustomer/module/applyRecord";
import maintainRecords from "@/view/myCustomer/module/maintainRecords";
import companyDetail from "@/view/myCustomer/module/companyDetail";
import productFilter from "@/view/productFilter";
import layerCode from "@/view/layerCode";
import leadInfo from "@/view/applyPage/leadInfo/leadInfo.vue";
import leadInfoNL from "@/view/applyPage/leadInfoNL/leadInfo.vue";
import leadInfoForXrr from "@/view/applyPage/leadInfoForXrr/leadInfo.vue";
import robot from "@/view/robot";
// 退役军人服务平台 xrr
import robotForXrr from "@/view/robotForXrr";
import robotTest from "@/view/robotTest";
import layerCodeForm from "@/view/layerCode/module/layerCodeForm";
import layerCodeDataList from "@/view/layerCode/module/layerCodeDataList";
import productNews from "@/view/productNews";
import previewImage from "@/view/previewImage";
import set from "@/view/userCenter/module/set";
import applyCenter from "@/view/applyCenter";
// ========== 通用组件（多平台复用） ==========
import Jxt from "@/components/Jxt.vue";  // 绩效通 - 通用组件
import PlatformLogin from "@/components/Login.vue";  // 统一登录页

// 保留企业服务组件（待合并）
import enterpriseServices from "@/view/reportCommon/enterpriseServices";
// 保留报告相关组件（待合并）
import reportPosterCenter from "@/view/reportCommon/reportPosterCenter";
import reportInterpre from "@/view/reportCommon/reportInterpre.vue";
import companyRepByReport from "@/view/reportCommon/companyRepByReport.vue";

import customerCenter from "@/view/customerCenter";
import accurateSearch from "@/view/customerCenter/module/accurateSearch";
import batchSearch from "@/view/customerCenter/module/batchSearch";
import store from "@/store";
import userCenter from "@/view/userCenter";
import { getWxUserInfo } from "../utils/index.js";
import { getDepNameByDomain } from "@/utils/index";
import { getPlatformCodeByDomain, getPlatformTypeConfig } from "@/config/platform.js";
Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: "/",
    //   name: "productList",
    //   component: productList,
    //   meta: {
    //     title: "企业数智服务中心",
    //     showFooter: true,
    //   },
    // },
    // 登录页已废弃，统一使用 PlatformLogin 组件
    // { path: "/login", name: "login", component: login, ... }
    {
      path: "/sign",
      name: "sign",
      component: sign,
      meta: {
        title: "用户注册",
      },
    },
    {
      path: "/robot",
      name: "robot",
      component: robot,
      meta: {
        title: "智能AI客服",
        // needLogin: true,
        showFooter: true,
      },
    },
    // 退役军人服务平台 xrr
    {
      path: "/robotForXrr",
      name: "robotForXrr",
      component: robotForXrr,
      meta: {
        title: "智能AI客服",
        showFooter: true,
      },
    },
    {
      path: "/robotTest",
      name: "robotTest",
      component: robotTest,
      meta: {
        title: "智能AI客服测试",
        // needLogin: true,
        showFooter: true,
      },
    },
    {
      path: "/imgPage",
      name: "imgPage",
      component: imgPage,
      meta: {
      },
    },
    {
      path: "/productDetail",
      name: "productDetail",
      component: productDetail,
      meta: {
        title: "产品详情",
      },
    },
    {
      path: "/userCenter",
      name: "userCenter",
      component: userCenter,
      meta: {
        needLogin: true,
        title: "个人中心",
        showFooter: true,
      },
    },
    {
      path: "/newsList",
      name: "newsList",
      component: newsList,
      meta: {
        title: "新闻列表",
      },
    },
    {
      path: "/productPoster",
      name: "productPoster",
      component: productPoster,
      meta: {
        needLogin: true,
        title: "分享",
      },
    },
    {
      path: "/productCollection",
      name: "productCollection",
      component: productCollection,
      meta: {
        // needLogin: true,
        title: "产品合集",
        showFooter: true,
      },
    },
    // 退役军人服务平台 xrr
    {
      path: "/productCollectionForXrr",
      name: "productCollectionForXrr",
      component: productCollectionForXrr,
      meta: {
        // needLogin: true,
        title: "我的",
        showFooter: true,
      },
    },
    {
      path: "/productNews",
      name: "productNews",
      component: productNews,
      meta: {
        needLogin: true,
        title: "全部动态",
      },
    },
    {
      path: "/set",
      name: "set",
      component: set,
      meta: {
        needLogin: true,
        title: "设置",
      },
    },
    {
      path: "/applyCenter",
      name: "applyCenter",
      component: applyCenter,
      meta: {
        needLogin: true,
        title: "查询中心",
        showFooter: true,
      },
    },
    {
      path: "/customerCenter",
      name: "customerCenter",
      component: customerCenter,
      meta: {
        needLogin: true,
        title: "拓客中心",
        showFooter: true,
      },
    },
    {
      path: "/productFilter",
      name: "productFilter",
      component: productFilter,
      meta: {
        needLogin: true,
        title: "智能匹配",
        keepAlive: true,
      },
    },
    {
      path: "/companyRep",
      name: "companyRep",
      component: companyRep,
      meta: {
        needLogin: true,
        title: "报告管理",
      },
    },
    {
      path: "/companyRepCode",
      name: "companyRepCode",
      component: companyRepCode,
      meta: {
        needLogin: true,
        title: "历史价格码管理",
      },
    },
    {
      path: "/companyRepCodeInfo",
      name: "companyRepCodeInfo",
      component: companyRepCodeInfo,
      meta: {
        needLogin: true,
        title: "企业报告",
      },
    },
    // 报告类租户 我的订单页面
    {
      path: "/companyRepByReport",
      name: "companyRepByReport",
      component: companyRepByReport,
      meta: {
        needLogin: true,
        title: "我的订单",
      },
    },
    {
      path: "/layerCode",
      name: "layerCode",
      component: layerCode,
      meta: {
        needLogin: true,
        title: "夹层码工具",
      },
    },
    {
      path: "/layerCodeForm",
      name: "layerCodeForm",
      component: layerCodeForm,
      meta: {
        needLogin: true,
        title: "夹层码工具",
      },
    },
    {
      path: "/layerCodeDataList",
      name: "layerCodeDataList",
      component: layerCodeDataList,
      meta: {
        needLogin: true,
        title: "夹层码工具",
      },
    },
    {
      path: "/reservation",
      name: "reservation",
      component: reservation,
      meta: {
        needLogin: true,
        title: "开户预约",
      },
    },
    {
      path: "/reservationRecord",
      name: "reservationRecord",
      component: reservationRecord,
      meta: {
        needLogin: true,
        title: "预约记录",
      },
    },
    {
      path: "/myCustomer",
      name: "myCustomer",
      component: myCustomer,
      meta: {
        needLogin: true,
        title: "我的客户",
        showFooter: true,
      },
    },
    {
      path: "/companyDetail",
      name: "companyDetail",
      component: companyDetail,
      meta: {
        needLogin: true,
        title: "企业信息",
        showFooter: false,
      },
    },
    {
      path: "/applyRecord",
      name: "applyRecord",
      component: applyRecord,
      meta: {
        needLogin: true,
        title: "进件记录",
        // showFooter: true,
      },
    },
    {
      path: "/maintainRecords",
      name: "maintainRecords",
      component: maintainRecords,
      meta: {
        needLogin: true,
        title: "维护记录",
        // showFooter: true,
      },
    },
    {
      path: "/accurateSearch",
      name: "accurateSearch",
      component: accurateSearch,
      meta: {
        needLogin: true,
        title: "精准搜索",
        // showFooter: true,
      },
    },
    {
      path: "/leadInfo",
      name: "leadInfo",
      component: leadInfo,
      meta: {
        needLogin: true,
        title: "融资申请",
        showFooter: true,
      },
    },
    {
      path: "/leadInfoNL",
      name: "leadInfoNL",
      component: leadInfoNL,
      meta: {
        title: "融资申请",
      },
    },
    {
      path: "/leadInfoForXrr",
      name: "leadInfoForXrr",
      component: leadInfoForXrr,
      meta: {
        title: "融资申请",
        showFooter: true,
      },
    },
    {
      path: "/accountCenter",
      name: "accountCenter",
      component: accountCenter,
      meta: {
        needLogin: true,
        title: "结算资料管理",
        // showFooter: true,
      },
    },
    {
      path: "/authentication",
      name: "authentication",
      component: authentication,
      meta: {
        needLogin: true,
        title: "编辑结算资料",
        // showFooter: true,
      },
    },
    {
      path: "/batchSearch",
      name: "batchSearch",
      component: batchSearch,
      meta: {
        needLogin: true,
        title: "批量反查",
        // showFooter: true,
      },
    },
    {
      path: "/productSummary",
      name: "productSummary",
      component: productSummary,
      meta: {
        needLogin: true,
        title: "统一进件",
      },
    },
    {
      path: "/supplementInfo",
      name: "supplementInfo",
      component: supplementInfo,
      meta: {
        // needLogin: true,
        title: "客户资料",
      },
    },
    {
      path: "/operatingManual",
      name: "operatingManual",
      component: operatingManual,
      meta: {
        needLogin: false,
        title: "办理指引",
      },
    },
    {
      path: "/searchProduct",
      name: "searchProduct",
      component: searchProduct,
      meta: {
        needLogin: false,
        title: "产品列表",
      },
    },
    {
      path: "/carLoanCustomers",
      name: "carLoanCustomers",
      component: carLoanCustomers,
      meta: {
        needLogin: false,
        title: "车贷客户",
      },
    },
    {
      path: "/posterPage",
      name: "posterPage",
      component: posterPage,
      meta: {
        needLogin: false,
        title: "功能指引",
      },
    },
    {
      path: "/productInformation",
      name: "productInformation",
      component: productInformation,
      meta: {
        // needLogin: true,
        title: "产品资料",
        // showFooter: true,
      },
    },
    {
      path: "/",
      name: "productList",
      component: productList,
      meta: {
        needLogin: false,
        title: "企业数智服务中心",
        showFooter: true,
      },
    },
    {
      path: "/productCardList",
      name: "productCardList",
      component: productCardListPage,
      meta: {
        needLogin: false,
        title: "产品列表",
        showFooter: false,
      },
    },
    {
      path: "/lowerLevelChannels",
      name: "lowerLevelChannels",
      component: lowerLevelChannels,
      meta: {
        needLogin: true,
        title: "下级渠道",
        showFooter: true,
      },
    },
    // 绩效会独立页面》》》》》》》》》》》》》》
    // 绩效会 绩效通
    {
      path: "/jxt",
      name: "jxt",
      component: Jxt,
      meta: {
        needLogin: false,
        title: "绩效通",
        showFooter: false,
      },
    },
    // 绩效会 更多服务
    {
      path: "/enterpriseServices",
      name: "enterpriseServices",
      component: enterpriseServices,
      meta: {
        needLogin: false,
        title: "更多服务",
        showFooter: false,
      },
    },
    // 绩效会 企业报告海报
    {
      path: "/reportPosterCenter",
      name: "reportPosterCenter",
      component: reportPosterCenter,
      meta: {
        needLogin: false,
        title: "企业报告海报",
        showFooter: false,
      },
    },
    // 绩效会 图片预览界面
    {
      path: '/previewImage',
      name: 'previewImage',
      component: previewImage,
      meta: {
        needLogin: false,
        showFooter: false,
      }
    },
    // 绩效会 登录页面 -> 统一登录页
    {
      path: '/loginByHpmra',
      redirect: '/login'
    },
    // 绩效会 注册页面 -> /sign
    {
      path: '/signByHpmra',
      redirect: '/sign'
    },
    // 绩效会 报告解读
    {
      path: '/reportInterpre',
      name: 'reportInterpre',
      component: reportInterpre,
      meta: {
        needLogin: false,
        showFooter: false,
        title: "AI报告解读",
      }
    },
    // ========== 报告解读多平台重定向 ==========
    {
      path: '/reportInterpreByWhicpa',
      redirect: '/reportInterpre'
    },
    {
      path: '/reportInterpreByzwrx',
      redirect: '/reportInterpre'
    },
    // ========== 多平台统一路由（平台感知） ==========
    // 统一登录页
    {
      path: '/login',
      name: 'PlatformLogin',
      component: PlatformLogin,
      meta: {
        needLogin: false,
        showFooter: false,
        title: "用户登录",
      }
    },
    // 统一绩效通
    {
      path: "/jxt",
      name: "Jxt",
      component: Jxt,
      meta: {
        needLogin: false,
        title: "绩效通",
        showFooter: false,
      },
    },

    // ========== 旧路由（已废弃，指向通用组件） ==========
    // 会计协会 登录页面 -> 统一登录页
    {
      path: '/loginByWhicpa',
      redirect: '/login'
    },
    // 会计协会 注册页面 -> /sign (现有)
    {
      path: '/signByWhicpa',
      redirect: '/sign'
    },
    // 会计协会 绩效通 -> /jxt
    {
      path: "/jxtByWhicpa",
      redirect: "/jxt"
    },
    // 会计协会 更多服务
    {
      path: "/enterpriseServicesByWhicpa",
      component: enterpriseServices,
      meta: { needLogin: false, title: "更多服务", showFooter: false },
    },
    // 会计协会 企业报告海报
    {
      path: "/reportPosterCenterByWhicpa",
      component: reportPosterCenter,
      meta: { needLogin: false, title: "企业报告海报", showFooter: false },
    },
    // 会计协会 企业报告记录
    {
      path: "/companyRepByWhicpa",
      component: companyRep,
      meta: { needLogin: false, title: "企业报告", showFooter: false },
    },
    // 中微融信 登录页面 -> 统一登录页
    {
      path: '/loginByzwrx',
      redirect: '/login'
    },
    // 中微融信 注册页面 -> /sign
    {
      path: '/signByzwrx',
      redirect: '/sign'
    },
    // 中微融信 绩效通 -> /jxt
    {
      path: "/jxtByzwrx",
      redirect: "/jxt"
    },
    // 中微融信 更多服务
    {
      path: "/enterpriseServicesByzwrx",
      component: enterpriseServices,
      meta: { needLogin: false, title: "更多服务", showFooter: false },
    },
    // 中微融信 企业报告海报
    {
      path: "/reportPosterCenterByzwrx",
      component: reportPosterCenter,
      meta: { needLogin: false, title: "企业报告海报", showFooter: false },
    },
    // 中微融信 企业报告记录
    {
      path: "/companyRepByzwrx",
      component: companyRep,
      meta: { needLogin: false, title: "企业报告", showFooter: false },
    },
  ],
});
// 等待初始化完成的辅助函数
function waitForInit(maxWait = 3000) {
  return new Promise((resolve) => {
    // 如果已经加载过，直接返回
    if (store.state.platformTypeLoaded) {
      console.log('[DEBUG] waitForInit: already loaded, platformType:', store.state.platformType);
      return resolve();
    }
    // 最多等待 maxWait ms
    const startTime = Date.now();
    const check = () => {
      if (store.state.platformTypeLoaded) {
        console.log('[DEBUG] waitForInit: loaded, platformType:', store.state.platformType);
        resolve();
      } else if (Date.now() - startTime > maxWait) {
        // 超时后使用默认的 portal 类型继续
        console.log('[DEBUG] waitForInit: timeout, continue with default');
        resolve();
      } else {
        setTimeout(check, 50);
      }
    };
    check();
  });
}

router.beforeEach(async (to, from, next) => {

  // 等待初始化完成
  await waitForInit();

  //检查cookie中是否有wxUserInfo，如果没有，进行认证回跳
  wxInterceptor(to, next);

  // 这一步是为了在有token的情况，拉取用户信息
  if (getToken()) {
    if (!store.getters.Login.roles) {
      console.log("有token，但没有保存登录信息，使用token拉取用户信息");
      // store.dispatch("Login", res)
      toPage(to, next);
    } else {
      console.log("有token，也有保存登录信息");
      toPage(to, next);
    }
  } else {
    console.log('[DEBUG] getToken() 返回空, cookie:', document.cookie);
    toPage(to, next);
  }
});

// 页面判断
function toPage(to, next) {
  console.log('[DEBUG] toPage - route name:', to.name, 'path:', to.path);

  // 从 store 获取平台类型，默认是 portal
  const platformType = store.state.platformType || 'portal';
  const platformConfig = getPlatformTypeConfig(platformType);
  console.log('[DEBUG] platformType:', platformType, 'requireLogin:', platformConfig.requireLogin);

  // 登录页（如果有登录信息的话，则直接跳转至首页）
  if (to.name === "PlatformLogin") {
    //检查是否有token
    if (getToken()) {
      console.log("有token，并且有用户登录信息，直接跳转至首页");
      next(platformConfig.afterLoginRoute || "/");
    } else {
      next();
    }
  }
  // 首页 "/" - 检查是否需要强制登录
  else if (to.path === "/" || to.name === "productList") {
    if (platformConfig.requireLogin) {
      // 需要登录的租户
      if (getToken()) {
        // 已登录，跳转到 afterLoginRoute
        next(platformConfig.afterLoginRoute || "/reportPosterCenter");
      } else {
        // 未登录，跳转到登录页
        next("/login");
      }
    } else {
      // 不需要登录的租户，直接访问首页
      next();
    }
  }
  // 其他页面
  else {
    // 需要登陆之后才可跳转的页面
    if (to.meta.needLogin) {
      console.log("需要登陆后才可跳转的页面");
      if (getToken()) {
        // 有token，允许跳转
        next();
      } else {
        // 没有token的话，前去登录
        next("/login");
      }
    }
    // 其他页面 直接跳转
    else {
      console.log("不需要登陆直接跳转的页面");
      next();
    }
  }
  window.scrollTo(0, 0);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
}

function wxInterceptor(to, next) {
  // ========== 本地调试开关 ==========
  const platformCode = getPlatformCodeByDomain();
  console.log('[DEBUG] 平台识别:', platformCode);
  // ========== 调试开关结束 ==========

  console.log("wx环境拦截");
  if (process.env.NODE_ENV === "development") return;
  if (!getWxUserInfo()) {
    let prefix = "https://wx1.xchengtech.cn/saas/getUserInfo?destination=code&depName=" + getDepNameByDomain() + "&url=";
    console.log("重新进行微信授权");
    prefix =
      prefix + encodeURIComponent(window.location.href);
    //跳转到url
    window.location.href = prefix;
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js